import axios from 'axios';

const state = {
	integrations: [],
	integration: {},
	index: '',
	sortBy: '',
	sortDesc: '',
	types: [],
};

const getters = {
	getIntegrations: state => state.integrations,
	getIntegration: state => state.integration,
	getIndex: state => state.index,
	getSortBy: state => state.sortBy,
	getSortDesc: state => state.sortDesc,
	getTypes: state => state.types,
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		const url = 'integrations';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['integrations/getSortBy'],
						sortDesc: context.rootGetters['integrations/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => {
				context.commit('setIntegrations', res.data.data);
				return res.data.pagination;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	fetchTypes: async context => {
		const url = 'integrations/types';
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				context.commit('setTypes', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	getDetailIntegration: async (context, payload) => {
		const url = `integrations/detail/${payload}`;
		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => ({ data: res.data }))
			.catch(err => {
				console.log('errore', err);
			});
	},

	deleteIntegrations: async (context, payload) => {
		const url = 'integrations/delete';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{ data: { query: payload } },
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)
			.then(res => res.data)
			.catch(err => {
				console.log('errore', err.response && err.response.status);
				return { error: err.response && err.response.status };
			});
	},

	destroyData: context => {
		context.commit('setIntegrations', []);
		context.commit('setIntegration', {});
	},
};

const mutations = {
	setIntegrations: (state, value) => {
		state.integrations = value;
	},
	setIntegration: (state, value) => {
		state.integration = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setTypes: (state, value) => {
		state.types = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};